export default {
    methods: {
        roundNum(value, decimals = 2, separator = '.') {

            let sign = value >= 0 ? 1 : -1
            let defaultSeparator = '.'

            return (Math.round((value*Math.pow(10,decimals))+(sign*0.001))/Math.pow(10,decimals))
                .toFixed(decimals)
                .replace(defaultSeparator, separator);
        },
    }
}
